<template>
    <div class="transactionPeriodMamMaster white border-radius5 mar-bot10">
        <div
                class="period-header module-header display-flex space-between"
        >
            <span class="title">{{$t('Trading_cycle')}}</span>
            <span v-if="detailsIsMaster && statistics.userStatus !== 0">
                <el-button
                        :loading="settleLoading"
                        v-if="statistics.userStatus == 3"
                        type="primary"
                        size="small"
                        @click="startUsingHandle"
                >{{$t('User.startUsing')}}</el-button>
                <el-tooltip class="item" effect="dark" placement="top">
                    <div
                            slot="content"
                            class="content"
                        style="width: 136px;"
                    >
                        <p class="">{{$t('Settlement_conditions')}}：</p>
                        <p>1.{{$t('cycleTips1')}}</p>
                        <p>2.{{$t('cycleTips2')}}</p>
                    </div>
                    <el-button
                            v-if="statistics.userStatus == 1"
                            size="small"
                            type="primary"
                            :loading="settleLoading"
                            @click="settleHandle"
                    >{{$t('settle')}}</el-button>
                </el-tooltip>
            </span>
        </div>
        <div class="el-table-outer-box">
          <el-table
            :data="listData"
            :empty-text="$t('root.noData')"
            v-loading="loading"
            class="el-table-el"
            @sort-change="sortChange"
            :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
          >
            <div class="table-nodata" slot="empty">
              {{$t('root.noData')}}
            </div>
            <el-table-column
              :label="$t('Issue')"
              prop="issueNumber"
              min-width="130px"
            >
            </el-table-column>
            <el-table-column
              :label="$t('Management_days')"
            >
              <template slot-scope="scope">
                <div>{{scope.row.times}}{{$t('day')}}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('Personal_funds')"
              prop="amount"
              sortable
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              :label="$t('Personal_gain')"
              prop="login"
              sortable
              min-width="100px"
            >
              <template slot-scope="scope">
                        <span class=""
                              :class="{
                            'theme-color': isIncludeMinus(scope.row.statProfit),
                            'theme-green': !isIncludeMinus(scope.row.statProfit),
                            }"
                        >{{scope.row.statProfit}}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('Manage_funds')"
              sortable
              prop="managementAmount"
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              :label="$t('Management_income')"
              sortable
              prop="managementProfit"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div
                  class="copy-yeild"
                  :class="{
                            'theme-color': isIncludeMinus(scope.row.managementProfit),
                            'theme-green': !isIncludeMinus(scope.row.managementProfit),
                            }"
                >{{scope.row.managementProfit}}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('management_fee')"
              prop="managementPrice"
              sortable
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              :label="$t('Performance_fee')"
              min-width="100px"
              prop="performancePrice"
              sortable
            >
              <template slot-scope="scope">
                <!--进行中和结算中的就是估算值,因为表现费有可能浮动 -->
                <span>{{scope.row.performancePrice}} <span
                  v-if="scope.row.status == 1 || scope.row.status == 2"
                >({{$t('Estimate')}})</span></span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('User.status')"
              prop="commission"
            >
              <template slot-scope="scope">
                        <span
                          class="pointer"
                        >
                            {{getStatus(scope.row.status)}}
                        </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-outer" v-if="total">
            <div class="paginnation-left">
              <size-change @sizeChange="sizeChange"></size-change>
              <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
            </div>
            <vs-pagination
              class="pagination-box"
              :max="max"
              :total="pageSize"
              v-model="page"
            ></vs-pagination>
          </div>
        </div>
    </div>
</template>

<script>
  import { addTradingCycle,settle } from '@/api/copy'
  import { isIncludeMinus } from '@/utils/common';
  import { mapGetters } from 'vuex';
  import initData2 from '@/mixins/initData';
  export default {
    name: 'transactionPeriodMamMaster',
    mixins: [initData2],
    data() {
      return {
        statistics:{
          userStatus: 0,
          times: 0
        },
        settleLoading: false
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.init();
      })
    },
    computed: {
      ...mapGetters(['userInfo','detailsIsMaster','currentMasterMtId','listRefresh']),
    },
    methods: {
      isIncludeMinus,
      beforeInit(){
        this.params = {
          mtId: this.$route.params.mtid,
          page: this.page- 1,// 需要减1
          size: this.size,
        };
        if(this.sort){
          this.params.sort = this.sort;
        }
        this.url = '/crm/reception/queryMasterTradingCycles';
        return true;
      },
      getStatus(status){
        switch (status) {
          case 1:
            return this.$t('withgold.statusDuring');
          case 2:
            return this.$t('Settlement');
          case 3:
            return this.$t('withgold.statusEnd');
        }
      },
      getRenew(item){
        switch (item.renew) {
          case 1:
            return this.$t('Yes');
          case 2:
            return this.$t('Not');
        }
      },
       startUsingHandle(){
        this.$confirm(this.$t('startBeforeTips'), this.$t('startBeforeTipsTitle'), {
          confirmButtonText: this.$t('root.confirm'),
          cancelButtonText: this.$t('root.cancle'),
          type: 'warning',
          customClass: 'self-messagebox-wrapper'
        }).then(() => {
          this.settleLoading = true;
          addTradingCycle({
            mtId: +this.$route.params.mtid,
          }).then((res) => {
            this.settleLoading = false;
            this.init();
            this.$message({
              message: this.$t('Successfully_activated'),
              type: 'success'
            })
          })
        }).catch(() => {
          this.settleLoading = false;
        });
      },
      settleHandle(){
        // 1判断是否少于15天
        // 2判断是否账户未空仓
        if(this.statistics.times < 15){
          this.$message({
            type: 'warning',
            message: this.$t('cycleTips1') + '，' + this.$t('Settlement_not_supported'),
          });
          return;
        }
        this.$confirm(this.$t('settleBeforeTips'), this.$t('Confirm_settlement'), {
          confirmButtonText: this.$t('root.confirm'),
          cancelButtonText: this.$t('root.cancle'),
          type: 'warning',
          customClass: 'self-messagebox-wrapper'
        }).then(() => {
          this.settleLoading = true;
          settle({
            mtId: +this.$route.params.mtid,
          }).then((res) => {
            this.settleLoading = false;
            this.$message({
              message:this.$t('withgold.operatingSuccess'),
              type: 'success'
            });
            this.init();
            this.$store.commit('setListRefresh', !this.listRefresh);
          }).catch((error) => {
            this.settleLoading = false;
          })
        }).catch(() => {
          //几点取消的提示
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.transactionPeriodMamMaster {
    .title {
        font-size:16px;
        font-weight: bold;
        color: #333333;
    }
}
</style>
